import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("h1", [_vm._v(_vm._s(_vm.labelProducers))]), _c("div", {
    staticClass: "search-global-container"
  }, [_vm.canManage() ? _c("div", {
    staticClass: "search-top-buttons"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      to: _vm.goToProducerDetails(0, false)
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s("new ".concat(_vm.labelProducer)) + " ")], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      placeholder: "Search for a ".concat(_vm.labelProducer),
      solo: "",
      "hide-details": "auto",
      "append-icon": "fa-search",
      loading: _vm.datatable_loading,
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.label,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias, "label", $$v);
      },
      expression: "searchCriterias.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.baseModel.numberOfProducers
    }
  })], 1)])]), _c("div", {
    staticClass: "container-centered"
  }, [_c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      headers: _vm.datatable_headers,
      items: _vm.baseModel.items,
      "item-key": "id",
      "items-per-page": _vm.searchCriterias.paging.limits,
      loading: _vm.datatable_loading,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.link",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [_c("router-link", {
          staticClass: "router-link --no-hover-underlined",
          attrs: {
            to: _vm.goToWineList(item.id)
          }
        }, [_vm._v(" Products ")]), _c("router-link", {
          staticClass: "router-link --no-hover-underlined",
          attrs: {
            to: _vm.goToProducerDetails(item.id)
          }
        }, [_vm._v(" Profile page ")])], 1)];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("paging", {
    attrs: {
      numberOfPages: _vm.baseModel.numberOfPages,
      currentPage: _vm.searchCriterias.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.searchCriterias.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.searchCriterias.paging, "limits", $$v);
      },
      expression: "searchCriterias.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.searchCriterias.paging.currentPage,
      limits: Number(_vm.searchCriterias.paging.limits),
      totalNumber: _vm.baseModel.numberOfProducers
    }
  })], 1)])]) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };